import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Container, Row, Col, Card, Badge } from 'react-bootstrap';
import Sidebar from '../../../../Components/Sidebar';
import getEnvConfig from '../../../../config';

function ChargerQRCodeDisplay() {
  const location = useLocation();
  const { backendUrl } = getEnvConfig();
  const [chargerData, setChargerData] = useState({
    uuid: location.state?.uuid || '',
    imageData: location.state?.imageData || '',
    ports: location.state?.ports || []
  });
  const [connectorTypes, setConnectorTypes] = useState({});
  const [loading, setLoading] = useState(true);

  // Fetch connector types to display names instead of just IDs
  useEffect(() => {
    const fetchConnectorTypes = async () => {
      try {
        const response = await fetch(`${backendUrl}/chargers/connector-types`);
        const data = await response.json();
        
        if (data.status === 'success') {
          // Create a lookup object with ID as key and name as value
          const typesMap = {};
          data.connector_types.forEach(type => {
            typesMap[type.id] = type.name;
          });
          setConnectorTypes(typesMap);
        }
      } catch (error) {
        console.error('Error fetching connector types:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchConnectorTypes();
  }, [backendUrl]);

  // Get connector type name from ID
  const getConnectorTypeName = (typeId) => {
    return connectorTypes[typeId] || `Type ${typeId}`;
  };

  return (
    <div style={{ display: 'flex' }}>
      <Sidebar />
      <Container fluid style={{ marginLeft: '5px' }}>
        <Row className="justify-content-center my-5">
          <Col md={10}>
            <h2 className="mb-4 text-center">Charger Registration Complete</h2>
            
            {/* Charger Info (for backward compatibility) */}
            <Card className="mb-4">
              <Card.Header className="bg-primary text-white">
                <h5 className="mb-0">Charger Information</h5>
              </Card.Header>
              <Card.Body>
                <Row className="mb-3">
                  <Col md={4}>
                    <h6>Charger UUID:</h6>
                    <p className="text-monospace">{chargerData.uuid}</p>
                  </Col>
                  <Col md={8} className="text-center">
                    <h6>Charger QR Code</h6>
                    {chargerData.imageData && (
                      <img 
                        src={chargerData.imageData} 
                        alt="Charger QR Code" 
                        style={{ maxWidth: '200px' }} 
                      />
                    )}
                    <p className="text-muted mt-2">
                      <small>Note: Individual port QR codes should be used instead of this charger QR code.</small>
                    </p>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
            
            {/* Port QR Codes */}
            <h3 className="mb-3">Port Information</h3>
            {chargerData.ports.length > 0 ? (
              <Row>
                {chargerData.ports.map((port, index) => (
                  <Col md={6} key={index} className="mb-4">
                    <Card>
                      <Card.Header className="bg-info text-white">
                        <h5 className="mb-0">
                          Port #{port.port_number} 
                          <Badge bg="secondary" className="ms-2">
                            {getConnectorTypeName(port.connector_type_id)}
                          </Badge>
                        </h5>
                      </Card.Header>
                      <Card.Body className="text-center">
                        <Row>
                          <Col md={6}>
                            <h6>Port UUID:</h6>
                            <p className="text-monospace">{port.uuid}</p>
                            <h6>Power Rating:</h6>
                            <p>{port.max_power_kw} kW ({port.port_amps} Amps)</p>
                            <h6>Connector Type:</h6>
                            <p>{getConnectorTypeName(port.connector_type_id)} (ID: {port.connector_type_id})</p>
                          </Col>
                          <Col md={6}>
                            <h6>Port QR Code</h6>
                            {port.qr_code && (
                              <img 
                                src={port.qr_code} 
                                alt={`Port ${port.port_number} QR Code`} 
                                style={{ maxWidth: '150px' }} 
                              />
                            )}
                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>
                  </Col>
                ))}
              </Row>
            ) : (
              <Card className="text-center p-4">
                <p>No port information available.</p>
              </Card>
            )}
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default ChargerQRCodeDisplay;
